export default __webpack_public_path__ + "static/media/dws2.1a122d60.svg";